import { render, staticRenderFns } from "./Offers.vue?vue&type=template&id=0f0c9a7d"
import script from "./Offers.vue?vue&type=script&lang=ts"
export * from "./Offers.vue?vue&type=script&lang=ts"
import style0 from "./Offers.vue?vue&type=style&index=0&id=0f0c9a7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports